import { MutationResult } from "@/api/utils/types"
import { IJuniferTicketUpdate } from "./JuniferTicketMutator.types"
import { useMutation } from "@/api/utils/useQuery"
import {
  BackofficeRestMutations,
  UpdateAccountTicketPayload,
} from "@/api/backofficeRest/mutations"
import { useCurrentAccountStore } from "@/stores/currentAccount"

export interface IJuniferTicketMutator {
  updateForAccount(): MutationResult<IJuniferTicketUpdate, void>
}

class JuniferTicketMutatorClass implements IJuniferTicketMutator {
  updateForAccount(): MutationResult<IJuniferTicketUpdate, void> {
    return useMutation({
      ...BackofficeRestMutations.account.updateTicket(),
      serializerFn: (
        data: IJuniferTicketUpdate,
      ): UpdateAccountTicketPayload => {
        const billingAccountId = useCurrentAccountStore().coreId.data
        if (!billingAccountId) throw new Error("Missing coreId")
        return {
          billingAccountId,
          juniferTicketId: data.id,
          body: {
            definitionCode: data.code,
            stepCode: data.stepCode,
            summary: data.summary,
            description: data.description,
          },
        }
      },
    })
  }
}

export const JuniferTicketMutator = new JuniferTicketMutatorClass()
